import React, { Fragment, useState, useEffect } from 'react'
import { Avatar, Button, makeStyles, Paper, TextField, Typography, Box} from '@material-ui/core';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined'
import HowToRegIcon from '@material-ui/icons//HowToReg';
import { DoneOutlined } from '@material-ui/icons';
import Parse from 'parse';
import { createTheme, ThemeProvider} from '@material-ui/core/styles';
import {FormControl, IconButton, InputAdornment, Input, InputLabel, CircularProgress, Container} from '@material-ui/core';
import {VisibilityOff, Visibility} from '@material-ui/icons';
import provinces from './provinces.json'
import locations from './locations.json'
import Select from "react-select";
import { getFromAPI } from '../helpers/sqlApiCalls';
import Swal from 'sweetalert2';
import axios from 'axios';




const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2, 8, 5, 8),
    },
    avatar: {
        margin: theme.spacing(2),
        backgroundColor: theme.palette.secondary.main,
    },
    submit: {
        margin: theme.spacing(3, 0, 0, 0),

    }
}));

const CreateUsuario = ({ setNavCreateUsuario, redirectToApp }) => {

    const classes = useStyles()

    const [name, setName] = useState('')
    const [clientCode, setClientCode] = useState('')
    const [email, setEmail] = useState('')
    const [e, setE] = useState(false)
    const [phone, setPhone] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [address, setAddress] = useState('')
    const [province, setProvince] = useState('')
    const [location, setLocation] = useState('')
    const [iva, setIva] = useState('')
    const [business, setBusiness] = useState('')
    const [two, setTwo] = useState(false)
    const [one, setOne] = useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const [arrProvinces, setArrProvinces] = useState([])
    const [arrLocations, setArrLocations] = useState([])
    const [arrVats, setArrVats] = useState([])
    const [loading, setLoading] = useState(false)
    

    const handleClickShowPassword = () => setShowPassword((show) => !show);



    useEffect( async ()=>{
        let arrProvins = [];
        for (let i in provinces.provincias) {
            arrProvins.push({
                label: provinces.provincias[i].nombre,
                value: provinces.provincias[i].id
            })
        }
        setArrProvinces(arrProvins)

        const vats = await getFromAPI("Vats")
        let arrVats = []
        for(let i in vats){
            arrVats.push({
                label: vats[i].n,
                value: vats[i].k
            })
        }
        setArrVats(arrVats)
        
    }, [])

    useEffect(() => {
        if(province != ''){
            setLocation('')
            setArrLocations([])
            let arrLocations = [];
            let localidadesForProvince = (locations.localidades).filter(e => e.provincia.id == province.value)
            for (let i in localidadesForProvince) {
                arrLocations.push({
                    label: localidadesForProvince[i].nombre,
                    value: localidadesForProvince[i].id
                })
            }
            setArrLocations(arrLocations)
        } 
    }, [province])

    
    const createCustomer = async () => {
        const a = {
            "a": {
                "a": address,
                "d": "Mi Dirección",
                "l": location.label,
                "s": province.label,
            }
        }
        const registeredCustomers = Parse.Object.extend('RegisteredCustomers')
        const query = new registeredCustomers();
        
        query.save({
            n: name,
            bn: business,
            e: email,
            ph: phone,
            a: a.a,
            iva: iva.value,
            p: password,
            envId: window.localStorage.getItem('envId'),
            admin: false,
            k: clientCode ? clientCode : null,
            st: {
                'catalogOrder': 'brand'
            },
            documentation: {
                cuit: {
                    number: "",
                    urlDoc: {}
                },
                brutos: {
                    monto: "",
                    urlDoc: {}
                }
            }
        }).then( async(x) => {
            if (x) {
                localStorage.client = x.get('k') ? x.get('k') : null
                localStorage.user = JSON.stringify({ ...x.attributes, id: x.id })

                const client = clientCode !== '' ? await getFromAPI("Clients", `k=${clientCode}`) : null
                const clientSellers = client && client[0] && client[0].s ? client[0].s : null

                const seller = clientSellers && Object.keys(clientSellers)[0] ? await getFromAPI("Sellers", `k=${Object.keys(clientSellers)[0]}`) : null
                localStorage.sellerCode = clientSellers && Object.keys(clientSellers)[0] ? Object.keys(clientSellers)[0] : null
                localStorage.sellerName = seller && seller[0] ? seller[0].n : null
                localStorage.clData = JSON.stringify({ "pl": client && client[0] && client[0].pl ? client[0].pl : global && global.licenseSettings && global.licenseSettings.defaultPriceList ? global.licenseSettings.defaultPriceList : null, "sc": client && client[0] && client[0].sc ? client[0].sc : null})
                localStorage.clInfo =  client && client[0] ? JSON.stringify(client[0]) : null
                if (x.get('admin')) {
                  localStorage.admin = true
                  setLoading(false)
                  Swal.fire({
                    icon: 'success',
                    title: 'Usted se ha registrado con exito!',
                    showConfirmButton: false,
                    timer: 2000
                  })
                  redirectToApp()
                } else {
                    localStorage.admin = false  
                    setLoading(false)
                    Swal.fire({
                        icon: 'success',
                        title: 'Usted se ha registrado con exito!',
                        showConfirmButton: false,
                        timer: 2000
                      })
                    redirectToApp()      
                }

                // AVISO DE REGISTRO POR MAIL

                const emailBody = `
                    <h3>DATOS DEL CLIENTE</h3>
                    <ul>
                        <li>Codigo: ${clientCode ? clientCode : "-"}</li>
                        <li>Nombre y Apellido: ${name}</li>
                        <li>Razón Social: ${business}</li>
                        <li>Corre electronico: ${email}</li>
                        <li>Teléfono: ${phone}</li>
                        <li>Dirección: ${address}</li>
                        <li>Provincia: ${province.label}</li>
                        <li>Localidad: ${location.label}</li>
                        <li>Condición de IVA: ${iva.value}</li>
                    </ul>
                `;

                
                await axios.post("http://157.230.55.48:5001/api/v1/kiri/sendDocumentation", {
                    email: 'Carlosyauri97@gmail.com',  
                    htmlEmail: emailBody,
                    title: 'REGISTRO NUEVO CLIENTE B2B'
                })
             
              }
        })
        .catch(e => console.log('err', e));
    }



    const dataVerification = async () => {
        setLoading(true)
        if (
            (email.indexOf('@') != (-1))
            &&
            (email.substring(email.indexOf('@') + 1).indexOf('.') != (-1))
        ) {
            if (phone.length == 10 || phone.length == 12 || phone.length == 13 || phone.length == 14) {
                if (password.match(/^(?=.*[0-9])(?=.*[A-Z])[a-zA-Z0-9!§±@€#£$%^&*()-_+=}{|"':;.,><?`~]{6,100}$/)) {
                    if (confirmPassword == password) {


                            const registeredCustomers = Parse.Object.extend('RegisteredCustomers')

                            const querycli = new Parse.Query(registeredCustomers)
                            const query = new Parse.Query(registeredCustomers);
                            query.equalTo('envId', window.localStorage.getItem('envId')).equalTo('e', email).doesNotExist('deletedAt');
                            querycli.equalTo('envId', window.localStorage.getItem('envId')).equalTo('k', clientCode).doesNotExist('deletedAt')

                            querycli.first().then((rc) => {
                                if (rc) {
                                    setLoading(false)
                                    Swal.fire('El código ingresado ya fue registrado por otro usuario')
                                }else{
                                    query.first().then((rc) => {
                                        if (rc) {
                                            setLoading(false)
                                            Swal.fire('El correo electronico ya fue registrado por otro usuario')
                                        }else{
                                            createCustomer()
                                        }
                                    })
                                }
                            })                   
                                    

                        
                    } else {
                        Swal.fire('Las contraseñas no coinciden') 
                    }
                } else {
                    Swal.fire('Las contraseñas no coinciden')
                }
            } else {
                setLoading(false)
                Swal.fire('El telefono debe tener 10, 12, 13 o 14 caracteres')   
            }
        } else {
            setLoading(false)
            Swal.fire('El formato del correo electrónico no es valido')  
        }
    }


    return (
        <Fragment>
            {loading ? 
            <Container style={{ alignItems: "center" }} elevation={1} className={classes.paper}>
                <CircularProgress style={{ marginTop: 10, marginBottom: 10 }} color="secondary" />
            </Container> :
            <Paper elevation={1} className={classes.paper}>
            <Avatar className={classes.avatar}>
                <HowToRegIcon />
            </Avatar>
            <Typography component="h1" variant="h5" style={{marginBottom: 20}} >
                Registrate
            </Typography>
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '100%', margin: 2, marginBottom: 15},
                }}
                noValidate
                autoComplete="off"
            >
                <TextField
                    inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0 } }}
                    margin="normal"
                    variant="standard"
                    fullWidth
                    label="Codigo cliente (campo opcional)"
                    autoComplete="nombre"
                    value={clientCode}
                    onChange={(e) => setClientCode(e.target.value)}
                    
                    
                    
                />
                <TextField
                    inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0 } }}
                    margin="normal"
                    variant="standard"
                    fullWidth
                    label="Nombre y Apellido"
                    autoComplete="nombre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    
                    
                    
                />
                <TextField
                    inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0  } }}
                    variant="standard"
                    margin="normal"
                    fullWidth
                    label="Razón Social"
                    autoComplete="razon"
                    value={business}
                    onChange={(e) => setBusiness(e.target.value)}
                    
                    
                    
                />
                <TextField
                    inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0  } }}
                    variant="standard"
                    margin="normal"
                    fullWidth
                    label="Correo electrónico"
                    autoComplete="email"
                    value={email}
                    // onChange={(e) => setEmail(e.target.value)}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        if (
                                (
                                    email 
                                    &&
                                    email.indexOf('@') != (-1)
                                    &&
                                    (email.substring(email.indexOf('@') + 1).indexOf('.')) != (-1)
                                )
                                || 
                                Object.values(email).length == 0
                            ) {
                                setE(false)
                            } else {
                                setE(true)
                            }
                        
                    }}
                    
                    
                    
                />
                {
                    e
                    &&
                    <p style={{ color: 'red', padding: '0px 2px', fontSize: 12, marginTop: 0}}>El formato del correo electrónico no es valido</p>
                }
                <TextField
                    inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0  } }}
                    variant="standard"
                    margin="normal"
                    fullWidth
                    label="Teléfono"
                    autoComplete="telefono"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    
                    
                    
                />  
                <FormControl 
                    style={{m: 1, width: '100%', margin: 2, marginBottom: 15}}
                    variant="standard">
                    <InputLabel htmlFor="standard-adornment-password">Contraseña</InputLabel>
                    <Input
                        inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0  } }}
                        id="standard-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            if ((e.target.value).match(/^(?=.*[0-9])(?=.*[A-Z])[a-zA-Z0-9!§±@€#£$%^&*()-_+=}{|"':;.,><?`~]{6,100}$/) || password.length == 0) {
                                setOne(false)
                            } else {
                                setOne(true)
                            }
                        }}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                            style={{padding: 0}}
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}                                         
                            >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                        }
                    />
                </FormControl>
                {
                    one
                    &&
                    <p style={{ color: 'red',
                    padding: '0px 2px',
                    fontSize: 12, marginTop: 0}}>La contraseña debe tener como minimo 6 caracteres, al menos un numero y una letra mayuscula. Sin espacios</p>
                }    
                <FormControl 
                    style={{m: 1, width: '100%', margin: 2, marginBottom: 15}}
                    variant="standard">
                    <InputLabel htmlFor="standard-adornment-confirmPassword">Confirmar contraseña</InputLabel>
                    <Input
                        inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0  } }}
                        id="standard-adornment-confirmPassword"
                        type={showPassword ? 'text' : 'password'}
                        onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            if (e.target.value == password || confirmPassword.length == 0) {
                                setTwo(false)
                            } else {
                                setTwo(true)
                            }
                        }}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                            style={{padding: 0}}
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}                                         
                            >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                        }
                    />
                </FormControl>

                {
                    confirmPassword !== password && confirmPassword.length > 0
                    &&
                    <p style={{ color: 'red',
                    padding: '0px 2px',
                    fontSize: 12,  marginTop: 0}}>Las contraseñas deben ser iguales</p>
                }

                <TextField
                    inputProps={{ style: { paddingTop: 6.5, paddingBottom: 6.5, paddingRight: 5, paddingLeft: 1, marginTop: 4, marginBottom: 0  } }}
                    variant="standard"
                    margin="normal"
                    fullWidth
                    label="Dirección"
                    autoComplete="direccion"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    
                    
                    
                />


                <div 
                    style={{m: 1, width: '100%', margin: 2, marginBottom: 18, marginTop: 10, display: 'flex', flexDirection: 'column'}}
                >
                    <InputLabel style={{marginBottom: 10, fontWeight: 'bold'}}>Provincia</InputLabel>
                    <div style={{width: '100%', marginLeft: '-1px'}}>
                        <Select
                            fullWidth
                            placeholder={"Seleccionar provincia"}
                            onChange={(e) => setProvince(e)}
                            value={province}
                            options={arrProvinces}
                            isSearchable={true}            
                        />
                    </div>
                    

                </div>

                <div 
                    style={{m: 1, width: '100%', margin: 2, marginBottom: 18, marginTop: 10, display: 'flex', flexDirection: 'column'}}
                >
                    <InputLabel style={{marginBottom: 10, fontWeight: 'bold'}}>Localidad</InputLabel>
                    <div style={{width: '100%', marginLeft: '-1px'}}>
                        <Select
                            fullWidth
                            placeholder={"Seleccionar localidad"}
                            onChange={(e) => setLocation(e)}
                            value={location}
                            options={arrLocations}
                            isSearchable={true}            
                        />
                    </div>
                    

                </div>

                <div 
                    style={{m: 1, width: '100%', margin: 2, marginBottom: 18, marginTop: 10, display: 'flex', flexDirection: 'column'}}
                >
                    <InputLabel style={{marginBottom: 10, fontWeight: 'bold'}}>Condición de IVA</InputLabel>
                    <div style={{width: '100%', marginLeft: '-1px'}}>
                        <Select
                            fullWidth
                            placeholder={"Seleccionar condicion"}
                            onChange={(e) => setIva(e)}
                            value={iva}
                            options={arrVats}
                            isSearchable={true}            
                        />
                    </div>
                    

                </div>
                
            </Box>
            {
                ( name.length != 0 && email.length != 0 && phone.length != 0 && password.length != 0 && confirmPassword.length != 0) ?
                <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={() => { dataVerification() }}
                    className={classes.submit}
                >
                    Registrarse
                </Button> :
                <Button
                disabled={true}
                fullWidth
                variant="contained"
                color="secondary"
                className={classes.submit}
                >
                    Registrarse
                </Button>
            }

            
            <Button
                fullWidth
                variant="text"
                color="secondary"
                onClick={() => { setNavCreateUsuario(false) }}
                className={classes.submit}
            >
                Volver al login
            </Button>
            </Paper>
            }
            
                   
        </Fragment>
    )
}

export default CreateUsuario